import { render, staticRenderFns } from "./AddPartnerModal.vue?vue&type=template&id=5c26e1e5&scoped=true&"
import script from "./AddPartnerModal.vue?vue&type=script&lang=js&"
export * from "./AddPartnerModal.vue?vue&type=script&lang=js&"
import style0 from "./AddPartnerModal.vue?vue&type=style&index=0&id=5c26e1e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c26e1e5",
  null
  
)

export default component.exports